module.exports = __webpack_public_path__ + "static/media/avatar.fb8a8c1c.jpg";